import React, { useState } from 'react';
import './styles.scss';
import { noop } from '../../../common/propTypes';
import FormInput from '../../../common/FormInput';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TERMS_AND_CONDITIONS_URL } from '../../../navigation/constants';
import {
    getSendReportError,
    getSendReportSuccessMessages,
    isReportSendingInProgress,
} from '../selectors';
import { sendLitterReportRequested } from '../actions';

function SendReport({
    submissionResponse,
    onReportRequest,
    isReportInProgress,
}) {
    const [tosAccepted, setTOSAccepted] = useState(false);
    const [email, setEmail] = useState(null);
    const [format] = useState('CSV');
    const [formatType, setFormatType] = useState('US');
    const [error, setError] = useState(null);
    const [campaign, setCampaign] = useState(false);

    return (
        <section className="emailReport primary-highlight">
            <div className="container">
                <div className="row justify-content-center mt-5 report-wrap">
                    <div className="col-sm-12 col-md-8 text-center pt-3 ">
                        <h2 className="f-42 p-0 extraBold text-center">
                            Download Your Report Via CSV. Enter Email Below To
                            Receive CSV File:
                        </h2>
                        <div className="clearfix"></div>
                        <div className="mt-2 mb-3">
                            <p className="text-center">
                                If you require more than 50,000 records, please
                                complete the ‘Expanded Data Request Form’ at the
                                bottom of this page.
                            </p>
                            {error ? <p>{error}</p> : null}
                        </div>
                        <form
                            method="POST"
                            onSubmit={(e) => {
                                e.preventDefault();

                                if (!tosAccepted) {
                                    setError(
                                        'Please accept terms and conditions for proceed',
                                    );
                                    return;
                                }

                                if (tosAccepted) {
                                    onReportRequest({
                                        email,
                                        format,
                                        formatType,
                                        campaign,
                                    });
                                }
                            }}
                        >
                            <div className="row justify-content-between emailInput">
                                <div className="col-md-9 text-left">
                                    <FormInput
                                        title="EMAIL ADDRESS"
                                        bootstrapIcon="icon2-mail"
                                    >
                                        <TextField
                                            type="email"
                                            required
                                            placeholder={'Enter email address'}
                                            onChange={(event) =>
                                                setEmail(event.target.value)
                                            }
                                        />
                                    </FormInput>
                                </div>
                                <div className="col-md-3 text-left">
                                    <div className="input-label">CSV Type</div>
                                    <div className="row mt-3">
                                        <div className="col-5 radio">
                                            <input
                                                type="radio"
                                                id={'US'}
                                                name={'format_type'}
                                                value={'US'}
                                                defaultChecked
                                                onChange={(event) =>
                                                    setFormatType(
                                                        event.target.value,
                                                    )
                                                }
                                            />
                                            <label htmlFor={'US'}>U.S</label>
                                        </div>
                                        <div className="col-5 radio">
                                            <input
                                                type="radio"
                                                id={'EURO'}
                                                name={'format_type'}
                                                value={'EURO'}
                                                onChange={(event) =>
                                                    setFormatType(
                                                        event.target.value,
                                                    )
                                                }
                                            />
                                            <label htmlFor={'EURO'}>Euro</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col">
                                    <div className="text-left custom-checkbox custom-control mb-0">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="customCheck1"
                                            required="required"
                                            onChange={() => {
                                                setTOSAccepted(!tosAccepted);
                                            }}
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="customCheck1"
                                        >
                                            I agree to follow the terms under
                                            which Litterati’s data is being
                                            shared, <br /> the
                                            <a
                                                className="anchor"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={TERMS_AND_CONDITIONS_URL}
                                            >
                                                <b>
                                                    {' '}
                                                    Creative Commons BY-SA 4.0
                                                    license{' '}
                                                </b>
                                            </a>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col">
                                    <div className="text-left custom-checkbox custom-control mb-0">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="customCheck2"
                                            onChange={() => {
                                                setCampaign(!campaign);
                                            }}
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="customCheck2"
                                        >
                                            I allow Litterati to email me with
                                            tips, resources & product updates
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col p-1 text-center">
                                    <button
                                        type="submit"
                                        className="btn-shadow col-6 btn btn-primary btn-send pt-3 pb-3"
                                        disabled={isReportInProgress}
                                    >
                                        {isReportInProgress
                                            ? 'Sending...'
                                            : 'SEND'}
                                    </button>
                                    {submissionResponse &&
                                        (Array.isArray(submissionResponse) ? (
                                            submissionResponse.map((res) => (
                                                <>
                                                    <p className="success-text">
                                                        {res}
                                                    </p>
                                                </>
                                            ))
                                        ) : (
                                            <p>{submissionResponse}</p>
                                        ))}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

SendReport.propTypes = {
    onReportRequest: PropTypes.func,
    submissionResponse: PropTypes.string,
    errorResponse: PropTypes.string,
    isReportInProgress: PropTypes.bool,
};

SendReport.defaultProps = {
    onReportRequest: noop,
    submissionResponse: null,
    errorResponse: null,
    isReportInProgress: false,
};

const mapStateToProps = (state) => {
    return {
        submissionResponse: getSendReportSuccessMessages(state),
        errorResponse: getSendReportError(state),
        isReportInProgress: isReportSendingInProgress(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onReportRequest: (requestDetails) =>
            dispatch(sendLitterReportRequested(requestDetails)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendReport);
